module.exports = __webpack_public_path__ + "img/2_проблемы фон_1.9cad5299.png";